import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  InputBase,
  IconButton,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import { FiMessageSquare, FiSearch } from "react-icons/fi";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { searchFriends } from "../redux/actions/PeerMenuListActions";
import { API_URL } from "../config/app-config";
import { withRouter } from "react-router";
import dummyimage from "../img/default_avatar.jpg";

const PAGE_SIZE = 100;

function FriendsCardV2({ history, workSpaceName, friendDescription }) {
  const dispatch = useDispatch();
  const { searchFriendsList } = useSelector(
    (state) => state.PeerPageFriendsList
  );

  const [state, setState] = useState({
    page: 0,
    friendsList: [],
    suggestHasMore: true,
    searchTerm: "",
  });

  const updateState = (name, value) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Initial fetch
  useEffect(() => {
    updateState("friendsList", []);
    updateState("page", 0);
    updateState("suggestHasMore", true);
    dispatch(searchFriends("", 0));
  }, []);

  // Append unique friends
  useEffect(() => {
    if (searchFriendsList && Array.isArray(searchFriendsList)) {
      const existingIds = new Set(state.friendsList.map((f) => f.uId));
      const newFriends = searchFriendsList.filter(
        (f) => !existingIds.has(f.uId)
      );

      if (newFriends.length < PAGE_SIZE) {
        updateState("suggestHasMore", false); // No more data
      }

      updateState("friendsList", [...state.friendsList, ...newFriends]);
    }
  }, [searchFriendsList]);

  const fetchMoreDataSuggestion = () => {
    const nextPage = state.page + 1;
    updateState("page", nextPage);
    dispatch(searchFriends(state.searchTerm, nextPage));
  };

  const handleSearch = (e) => {
    const term = e.target.value;
    updateState("searchTerm", term);
    updateState("page", 0);
    updateState("friendsList", []);
    updateState("suggestHasMore", true);
    dispatch(searchFriends(term, 0));
  };

  const filteredFriends = state.friendsList.filter((friend) =>
    friend.dName.toLowerCase().includes(state.searchTerm.toLowerCase())
  );

  return (
    <div style={{ height: "100%", background: "#f8f9fa", borderRadius: 12 }}>
      {/* Search Bar */}
      <div
        style={{
          padding: "12px 16px",
          background: "#ffffff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <InputBase
          fullWidth
          placeholder="Search members..."
          value={state.searchTerm}
          onChange={handleSearch}
          startAdornment={
            <FiSearch style={{ marginRight: 8, color: "#6b778c" }} />
          }
          style={{
            backgroundColor: "#f1f3f5",
            borderRadius: "24px",
            padding: "8px 16px",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Scrollable Member List */}
      <InfiniteScroll
        dataLength={filteredFriends.length}
        next={fetchMoreDataSuggestion}
        hasMore={state.suggestHasMore}
        loader={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "16px",
            }}
          >
            <CircularProgress size={22} />
          </div>
        }
        style={{ overflowX: "hidden" }}
        // height="calc(100vh - 180px)"
        height="66dvh"
        scrollableTarget="scrollableDiv"
      >
        <List id="scrollableDiv" style={{ padding: 0 }}>
          {filteredFriends.length > 0 ? (
            filteredFriends.map((item, index) => (
              <div key={item.uId}>
                <ListItem
                  button
                  onClick={() => friendDescription(item.uId)}
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#ffffff",
                    borderRadius: 8,
                    margin: "8px 12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      src={`${API_URL}api/getUserPhoto/${item.uId}/${item.dName}`}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = dummyimage;
                      }}
                      style={{
                        width: 44,
                        height: 44,
                        border: "1px solid #e2e2e2",
                      }}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 600 }}
                      >
                        {item.dName}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        style={{ color: "#6b778c", fontSize: "0.85rem" }}
                      >
                        {item.title || "Member"}
                      </Typography>
                    }
                  />
                  <IconButton size="small">
                    <FiMessageSquare />
                  </IconButton>
                </ListItem>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "24px" }}>
              <Typography variant="body1">
                {state.searchTerm ? "No matching members" : "No members found"}
              </Typography>
            </div>
          )}
        </List>
      </InfiniteScroll>
    </div>
  );
}

export default withRouter(FriendsCardV2);
